<template>
    <ModalWrapper v-model="isShowModal" :subtitle="$t('api.info_title')">
        <template v-slot:activator>
            <slot name="activator" />
        </template>
        <template v-slot:title>
            {{ $t('api.access_to_api') }}
        </template>
        <template v-slot:content>
            <slot name="apiKey" />
            <div>
                {{ $t('api.read_more_title') }}
                <a class="text-subtitle-2" style="word-break: break-all" :href="documentationLink" target="_blank">
                    {{ documentationLink }}
                </a>
            </div>
            <div>
                {{ $t('api.api_methods_title') }}
                <a class="text-subtitle-2" style="word-break: break-all" :href="swaggerLink" target="_blank">
                    {{ swaggerLink }}
                </a>
            </div>
        </template>
    </ModalWrapper>
</template>
<script setup lang="ts">
    const isShowModal = defineModel<boolean>()

    const documentationLink =
        'https://gp-team.atlassian.net/wiki/spaces/GPTEAPI/pages/1868267524/GPTE+API+TECHNICAL+DOCUMENTATION'
    const swaggerLink = fullUrl('/stat/swagger/index.html')
</script>
